import React from 'react';
import PropTypes from 'prop-types';
import objectAssign from 'object-assign';

var Lens = function Lens(props) {
    var fadeDurationInMs = props.fadeDurationInMs,
        isActive = props.isActive,
        isPositionOutside = props.isPositionOutside,
        style = props.style,
        translateX = props.translateX,
        translateY = props.translateY;

    var translate = 'translate(' + translateX + 'px, ' + translateY + 'px)';
    var computedStyle = {
        position: 'absolute',
        transform: translate,
        WebkitTransform: translate,
        msTransform: translate,
        opacity: isActive && !isPositionOutside ? 1 : 0,
        transition: 'opacity ' + fadeDurationInMs + 'ms ease-in'
    };
    var defaultStyle = {
        width: 'auto',
        height: 'auto',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        display: 'block'
    };

    return React.createElement('div', { style: objectAssign({}, defaultStyle, style, computedStyle) });
};

Lens.propTypes = {
    style: PropTypes.object,
    fadeDurationInMs: PropTypes.number,
    isActive: PropTypes.bool,
    translateX: PropTypes.number,
    translateY: PropTypes.number,
    userStyle: PropTypes.object
};

Lens.defaultProps = {
    isActive: false,
    fadeDurationInMs: 0,
    translateX: 0,
    translateY: 0
};

export default Lens;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-image-magnify/dist/es/shaded-lens/Lens.js
// module id = 34
// module chunks = 0